import BillingsTaxiUnbilledRouteListingByRailyTaxiCorporationSelectOption from "./types/billings-taxi-unbilled-route-listing-by-raily-taxi-corporation-select-option";
import billingsTaxiUnbilledRouteListingFactory from "../../common/billings-taxi-unbilled-route-listing.factory";
import { TaxiCorporationListItem } from "../../../../../../common/services/taxi-corporation/list/taxi-corporation-list";

const createTaxiCorporationSelectOption = (
  responseTaxiCorporation: TaxiCorporationListItem,
): BillingsTaxiUnbilledRouteListingByRailyTaxiCorporationSelectOption => {
  return {
    label: responseTaxiCorporation.displayName,
    value: {
      uuid: responseTaxiCorporation.uuid,
      displayName: responseTaxiCorporation.displayName,
    },
  };
};

const createTaxiCorporationSelectOptions = (
  responseTaxiCorporations: TaxiCorporationListItem[],
): BillingsTaxiUnbilledRouteListingByRailyTaxiCorporationSelectOption[] => {
  return responseTaxiCorporations.map(createTaxiCorporationSelectOption);
};

const billingsTaxiUnbilledRouteListingByRailyFactory = {
  createTaxiCorporationSelectOptions,
  createListingItems:
    billingsTaxiUnbilledRouteListingFactory.createListingItems,
};

export default billingsTaxiUnbilledRouteListingByRailyFactory;
